import { REST_API_CONFIG } from "./config.js";

export class Api {
  constructor(api) {
    this.name = api.name;
    this.url = api.url;
    this.test = api.test || { url: "", type: "json", enabled: false };
    if (this.test.enabled == "true") {
      this.test.enabled = true;
    } else if (this.test.enabled == "false") {
      this.test.enabled = false;
    }
    this.route = api.route || "";
    this.onError = api.onError;
    this.cache = api.cache || false;
    this.response = {};
    this.contentType = api.contentType || "application/json; charset=utf-8";
    this.paramset = api["params"] || null;
    this.param = api.param || {};
    this.type = api.type || "GET";
    if (api.errorHandler && typeof api.errorHandler == "function") {
      this.errorHandler = api.errorHandler;
    }
    this.timeout = api.timeout || 120000; // 2분?
    this.integrations = api.integrations || {};
    this.xhrFields = api.xhrFields || null;
    return this;
  }
  setOption(key, value) {
    this[key] = value;
  }
  getName() {
    return this.name;
  }
  setRoute(route) {
    this.route = route;
    return this;
  }
  setParam(paramObj) {
    this.param = paramObj;
    this.test.param = paramObj;
    return this;
  }
  getContentType() {
    return this.contentType;
  }
  getUrl() {
    let url = ""; //  기본 setting
    if (this.url.indexOf("http") > -1) {
      url = this.url;
    } else {
      if (this.route) {
        url = this.route + this.url;
      } else {
        url = REST_API_CONFIG.BASE_URL + this.url;
      }
    }

    let regParam = new RegExp(/\${([a-z.-]+)}/gi);
    // replace
    url = url.replace(regParam, (...args) => {
      try {
        let value = this.param[args[1]];
        if (value != undefined || value != null) {
          return value;
        } else {
          throw new $ex.UndefinedValue(
            "api.js- getUrl",
            "PathParameter " + args[1] + " is " + value,
          );
        }
      } catch (e) {
        throw new $ex.UndefinedValue(
          "api.js -  getUrl ",
          "PathParameter 오류 :  " + args[1],
        );
      }
    });

    return url;
  }
  replacer(text, data) {
    if (typeof text !== "string") {
      return "default";
    }
    let regParam = new RegExp(/\${([a-z.]+)}/gi);
    return text.replace(regParam, (...args) => {
      try {
        let value = data[args[1]];
        if (value != undefined || value != null) {
          return value;
        } else {
          throw Error();
        }
      } catch (e) {
        console.log(e);
        throw new $ex.UndefinedValue(
          "api.js -  replacer ",
          "replacer 오류 :  " + args[1],
        );
      }
    });
  }

  getType() {
    return this.type;
  }
  getData() {
    let parameters = {};
    if (this.paramset && this.paramset instanceof Array) {
      this.paramset.forEach((p) => {
        parameters[p] = this.param[p] || "";
      });
    } else {
      parameters = this.param;
    }

    let type = this.getType();
    if (type === "GET" || type === "DELETE") {
      return parameters;
    } else {
      return JSON.stringify(parameters || {});
    }
  }
  callNonPromise() {
    // 바로호출  response 를 기다리지 않는다.
    let ins = this;
    $.ajax({
      contentType: this.contentType,
      type: this.getType(),
      url: this.getUrl(),
      data: this.getData(),
      error: function (xhr, textStatus, error) {
        ins.errorHandler.call(ins, xhr, textStatus, error);
      },
      success: function (response, status, xhr) {
        ins.response = ins.successHandler(response, status, xhr, this.data);
      },
    });
  }
  get(reset) {
    this.type = "GET";
    return this.getResponse(reset);
  }
  post() {
    this.type = "POST";
    return this.getResponse(true);
  }
  update() {
    this.type = "PUT";
    return this.getResponse(true);
  }
  delete() {
    this.type = "DELETE";
    return this.getResponse(true);
  }
  getTest(type, data, reset) {
    return new Promise((resolve, reject) => {
      $.ajax({
        contentType: this.contentType,
        type: "GET",
        url: this.getUrl(),
        timeout: this.timeout,
        error: function (xhr, textStatus, error) {
          reject(xhr, data);
          throw new $ex.ConnectionFailed(
            "api- getTest",
            "** testData loading 실패 ** \n url : " +
              this.type +
              this.url +
              "\n status: " +
              xhr.status +
              "\n response: " +
              xhr.responseText || "",
          );
        },
        success: function (response, status, xhr) {
          let result = {
            response: jsyaml.load(response),
            data: data,
          };
          resolve(result, data);
        },
      });
    });
  }
  getResponseObject(type) {
    // 어떤 요청이든 object 로 받는다.
    return this.getResponse(type).then((v) => {
      if (v.response instanceof Array) {
        v.response = v.response[0];
      }
      return v;
    });
  }
  errorHandler(xhr, textStatus, error) {
    if (this.onError) {
      if (typeof this.onError == "function") {
        this.onError(xhr);
      }
    }
  }
  successHandler(response, status, xhr, data) {
    if (this.type === "DELETE" && xhr.status === 204) {
      return response;
    }
    if (xhr.status === 204 && response === undefined) {
      return response;
    }
    let result = {
      response: response["body"] ? response["body"] : response,
      data: data ? JSON.parse(data) : "",
    };
    return result;
  }
  getResponse(reset) {
    let data = this.getData(),
      apiName = this.getName();
    let ins = this;
    if (this.test.enabled && this.test.type == "yaml") {
      return this.getTest(this.getType(), data);
    } else {
      let cacheKey = "default";
      if (this.cache) {
        cacheKey = this.replacer(this.cache, data);
      }
      return new Promise((resolve, reject) => {
        if (!reset && this.cache && this.response[cacheKey]) {
          resolve(ins.response[cacheKey], data);
        } else {
          let request = $.ajax(
            $.extend(
              {
                contentType: this.contentType,
                type: this.getType(),
                url: this.getUrl(),
                data: data,
                cache: false,
                maxContentLength: 100000000,
                maxBodyLength: 1000000000,
                timeout: this.timeout,
                xhrFields: this.xhrFields,
                error: function (xhr, textStatus, error) {
                  // window.errorHandlerCallback(xhr);
                  if (xhr.status == 401) {
                    if (
                      document.querySelectorAll("#v-Unauthorized").length == 0
                    ) {
                      AuthManager.fn.showLogoutAlert();
                    }
                    return;
                  }
                  ins.errorHandler.call(ins, xhr, textStatus, error);
                  reject(xhr, data);
                },
                success: function (response, status, xhr) {
                  ins.response[cacheKey] = ins.successHandler(
                    response,
                    status,
                    xhr,
                    this.data,
                  );
                  resolve(ins.response[cacheKey], data);
                },
              },
              this.integrations,
            ),
          );
        }
      });
    }
  }
}
